<div *ngFor="let item of list.list">
    <p a-style fs=2 fw=500>{{item?.contacts?.basicDetails?.first_name}} {{item?.contacts?.basicDetails?.last_name}}</p>
    <p a-style fs=2 fw=500>{{item?.contacts?.basicDetails?.mobile}}</p>
    <img [src]="'https://new-api.mesbro.com/uploads/'+item.contacts?.basicDetails?.profile" a-style h=10 w=10>
</div>
